import CampaignActionTypes from './types';

const initialState = {
  campaigns: [],
  campaignDetails: null,
  campaignDetailsGifts: [],
  campaignGiftOperators: [],
  isFetchigCampaigns: false,
  isFetchingCampaignGifts: false,
  isFetchingCampaign: false,
  errorFetchingCampaign: null,
  isSavingCampaignGift: false,
  isSavingCampaign: false,
  didSaveCampaignGift: false,
  isPublishingCampaign: false,
  didPublishCampaign: false,
  isGeneratingCampaignQRCodes: false,
  didGenerateCampaignQRCodes: false,
  isDeletingCampaignGift: false,
  hasDeletedCampaignGift: false,
  isFetchingCampaignGiftOperators: false,
  hasFetchedCampaignGiftOperators: false,
};

const campaignReducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case CampaignActionTypes.FETCH_CAMPAIGNS_SUCCESS: {
      return { ...state, campaigns: payload };
    }
    case CampaignActionTypes.FETCH_CAMPAIGN_DETAILS_SUCCESS: {
      return { ...state, campaignDetails: payload };
    }
    case CampaignActionTypes.SET_CAMPAIGN_STATE: {
      return { ...state, ...payload };
    }
    case CampaignActionTypes.FETCH_CAMPAIGN_GIFTS_SUCCESS: {
      return { ...state, campaignDetailsGifts: payload };
    }
    case CampaignActionTypes.ADD_CAMPAIGN_GIFT: {
      return { ...state, campaignDetailsGifts: [...state.campaignDetailsGifts, payload] };
    }
    case CampaignActionTypes.EDIT_CAMPAIGN_GIFT: {
      return {
        ...state,
        campaignDetailsGifts: [
          ...state.campaignDetailsGifts.map(gift => {
            return gift.tempId === payload.gift.tempId ? payload.gift : gift;
          }),
        ],
      };
    }
    default: {
      return state;
    }
  }
};

export default campaignReducer;
